/* eslint-disable indent */
/* eslint-disable no-console */

// export const removeItemFromLocalStorage = () => {
//     localStorage.removeItem('modelOpenDuplicate');
//     if (localStorage.getItem('ro-dict')) {
//         localStorage.removeItem('ro-dict');
//     }
//     if (localStorage.getItem('ro_payload')) {
//         localStorage.removeItem('ro_payload');
//     }
//     if (localStorage.getItem('system-units')) {
//         localStorage.removeItem('system-units');
//     }
//     if (localStorage.getItem('default_unit_set_dict')) {
//         localStorage.removeItem('default_unit_set_dict');
//         localStorage.removeItem('previous_ro_pressure_unit');
//     }
//     if (localStorage.getItem('stream_ouput_data')) {
//         localStorage.removeItem('stream_ouput_data');
//         localStorage.removeItem('unit_set_dict');
//     }
//     if (localStorage.getItem('ro_ouput_data')) {
//         localStorage.removeItem('ro_ouput_data');
//     }
//     if (localStorage.getItem('form')) {
//         localStorage.removeItem('form');
//     }
//     if (localStorage.getItem('feed-dict')) {
//         localStorage.removeItem('feed-dict');
//     }
//     if (localStorage.getItem('dosing-dict')) {
//         localStorage.removeItem('dosing-dict');
//     }
//     if (localStorage.getItem('cf-dict')) {
//         localStorage.removeItem('cf-dict');
//     }
//     if (localStorage.getItem('edi-dict')) {
//         localStorage.removeItem('edi-dict');
//     }
//     if (localStorage.getItem('pump-dict')) {
//         localStorage.removeItem('pump-dict');
//     }
//     if (localStorage.getItem('hp-pump-dict')) {
//         localStorage.removeItem('hp-pump-dict');
//     }
//     if (localStorage.getItem('options')) {
//         localStorage.removeItem('options');
//     }
//     if (localStorage.getItem('ro-stage-data')) {
//         localStorage.removeItem('ro-stage-data');
//     }
//     if (localStorage.getItem('mixSplit-dict')) {
//         localStorage.removeItem('mixSplit-dict');
//     }
//     if (localStorage.getItem('previous_flow_unit')) {
//         localStorage.removeItem('previous_flow_unit');
//     }
//     if (localStorage.getItem('previous_pressure_unit')) {
//         localStorage.removeItem('previous_pressure_unit');
//     }
//     if (localStorage.getItem('previous_power_unit')) {
//         localStorage.removeItem('previous_power_unit');
//     }
//     if (localStorage.getItem('cf-output-dict')) {
//         localStorage.removeItem('cf-output-dict');
//     }
//     if (localStorage.getItem('streamNum_dict')) {
//         localStorage.removeItem('streamNum_dict');
//     }
//     if (localStorage.getItem('stripper-dict')) {
//         localStorage.removeItem('stripper-dict');
//     }
//     if (localStorage.getItem('cd-output-dict')) {
//         localStorage.removeItem('cd-output-dict');
//     }
//     if (localStorage.getItem('edi-output-dict')) {
//         localStorage.removeItem('edi-output-dict');
//     }
//     if (localStorage.getItem('project_info')) {
//         localStorage.removeItem('project_info');
//     }
//     if (localStorage.getItem('flow_dict')) {
//         localStorage.removeItem('flow_dict');
//     }
//     if (localStorage.getItem('feed_flow_dict')) {
//         localStorage.removeItem('feed_flow_dict');
//     }
//     if (localStorage.getItem('product_flow_dict')) {
//         localStorage.removeItem('product_flow_dict');
//     }
//     if (localStorage.getItem('stream_input_dict')) {
//         localStorage.removeItem('stream_input_dict');
//     }
//     if (localStorage.getItem('ro_argo_temp')) {
//         localStorage.removeItem('ro_argo_temp');
//     }
//     if (localStorage.getItem('work_exc-dict')) {
//         localStorage.removeItem('work_exc-dict');
//     }
//     if (localStorage.getItem('press_exc-dict')) {
//         localStorage.removeItem('press_exc-dict');
//     }
//     if (localStorage.getItem('pelton_wheel-dict')) {
//         localStorage.removeItem('pelton_wheel-dict');
//     }
//     if (localStorage.getItem('ro-dict-temp')) {
//         localStorage.removeItem('ro-dict-temp');
//     }
//     if (localStorage.getItem('current-unit-work')) {
//         localStorage.removeItem('current-unit-work');
//     }
//     if (localStorage.getItem('pelton-unit-work')) {
//         localStorage.removeItem('pelton-unit-work');
//     }
//     if (localStorage.getItem('turbo-unit-work')) {
//         localStorage.removeItem('turbo-unit-work');
//     }
//     if (localStorage.getItem('unit_set_dict')) {
//         localStorage.removeItem('unit_set_dict');
//     }
//     if (localStorage.getItem('turbo_charger-dict')) {
//         localStorage.removeItem('turbo_charger-dict');
//     }
//     if (localStorage.getItem('feedRows')) {
//         localStorage.removeItem('feedRows');
//     }
//     if (localStorage.getItem('previous_units')) {
//         localStorage.removeItem('previous_units');
//     }
//     if (localStorage.getItem('systemRecovery')) {
//         localStorage.removeItem('systemRecovery');
//     }
//     if (localStorage.getItem('clro-dict')) {
//         localStorage.removeItem('clro-dict');
//     }
//     if (localStorage.getItem('clro_payload')) {
//         localStorage.removeItem('clro_payload');
//     }
//     if (localStorage.getItem('clro-dict-temp')) {
//         localStorage.removeItem('clro-dict-temp');
//     }
//     if (localStorage.getItem('clro-stage-data')) {
//         localStorage.removeItem('clro-stage-data');
//     }
//     if (localStorage.getItem('clro_ouput_data')) {
//         localStorage.removeItem('clro_ouput_data');
//     }
//     if (localStorage.getItem('tds')) {
//         localStorage.removeItem('tds');
//     }
// };

// code guru suggestion
export const removeItemFromLocalStorage = () => {
	try {
		const safeRemove = (removeKey) => {
			removeKey.map((key) => {
				const sanitizedKey = encodeURIComponent(key).replace(/[^a-zA-Z0-9-_]/g, '');
				if (localStorage.getItem(sanitizedKey)) {
					localStorage.removeItem(sanitizedKey);
				}
			});
		};
		const removeKey = [
			'modelOpenDuplicate', 'ro-dict', 'ro_payload', 'system-units', 'Active_DualequationCCPP', 'StandAloneARGO',
			'default_unit_set_dict', 'previous_ro_pressure_unit', 'stream_ouput_data',
			'unit_set_dict', 'ro_ouput_data', 'form', 'feed-dict', 'dosing-dict',
			'cf-dict', 'edi-dict', 'pump-dict', 'hp-pump-dict', 'options', 'ro-stage-data',
			'mixSplit-dict', 'previous_flow_unit', 'previous_pressure_unit', 'previous_power_unit',
			'cf-output-dict', 'streamNum_dict', 'stripper-dict', 'cd-output-dict', 'edi-output-dict',
			'project_info', 'flow_dict', 'feed_flow_dict', 'product_flow_dict', 'stream_input_dict',
			'ro_argo_temp', 'work_exc-dict', 'press_exc-dict', 'pelton_wheel-dict', 'ro-dict-temp',
			'current-unit-work', 'pelton-unit-work', 'turbo-unit-work', 'unit_set_dict', 'turbo_charger-dict',
			'feedRows', 'previous_units', 'systemRecovery', 'clro-dict', 'clro_payload', 'clro-dict-temp',
			'clro-stage-data', 'clro_ouput_data', 'tds', 'shared_file_count'
		];
		safeRemove(removeKey);
	} catch (error) {
		console.error('Error in removeItemFromLocalStorage:', error.message);
	}
};